import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";

// Shared "fade to white then land home" transition — pure opacity (GPU-cheap, never choppy).
export function useHomeTransition() {
  const navigate = useNavigate();
  const location = useLocation();
  const reduce = useReducedMotion();
  const [leaving, setLeaving] = useState(false);

  const goHome = () => {
    if (leaving || location.pathname === "/") return;
    if (reduce) {
      navigate("/", { state: { fromInterior: true } });
      return;
    }
    setLeaving(true);
    setTimeout(() => navigate("/", { state: { fromInterior: true } }), 480);
  };

  return { leaving, goHome };
}

export function WhiteOut({ show }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[85] bg-white pointer-events-none"
          style={{ willChange: "opacity", backfaceVisibility: "hidden" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.55, ease: [0.65, 0, 0.35, 1] }}
        />
      )}
    </AnimatePresence>
  );
}
